// const waveCartUtils = (function () {
//   function post (url, body) {
//     return fetch(url, {
//       method: "POST",
//       body: JSON.stringify(body),
//       credentials: "same-origin",
//       headers: {
//         "Content-Type": "application/json",
//       },
//     });
//   }

//   function get (url) {
//     return fetch(url, {
//       credentials: "same-origin",
//       method: "GET",
//     });
//   }

//   function getCart () {
//     var url = "".concat(theme.routes.cartJs, `?t=${Date.now()}`);
//     return get(url).then((response) => response.json());
//   }

//   function changeItem ({
//     key,
//     quantity,
//     properties,
//   }) {
//     return post(theme.routes.cartJsChange, {
//       id: key,
//       quantity: quantity,
//       properties: properties,
//     });
//   }

//   function addItems (
//     items,
//     sections,
//     sections_url,
//   ) {
//     return post(theme.routes.cartJsAdd, {
//       items,
//       sections,
//       sections_url,
//     });
//   }

//   async function clearAddOn () {
//     const cart = await getCart();
//     const unissuedAddOns = cart.items.filter((item) => {
//       return (
//         item.properties["__add_on"] && !item.properties["__add_on"]["issued"]
//       );
//     });

//     const param = { updates: {} };
//     for (const item of unissuedAddOns) {
//       param.updates[item.key] = 0;
//     }
//     if (unissuedAddOns.length > 0) {
//       await post(theme.routes.cartJsUpdate, param);
//     }
//     return unissuedAddOns.length > 0;
//   }

//   function getRandomInt(min, max) {
//     min = Math.ceil(min);
//     max = Math.floor(max);
//     return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
//   }

//   return {
//     changeItem: changeItem,
//     getCart: getCart,
//     addItems: addItems,
//     clearAddOn: clearAddOn,
//     getRandomInt: getRandomInt
//   };
// })();


class MealkitDatepicker extends HTMLElement {
  constructor() {
    super();
    this.leadTime = Number(this.dataset.leadTime);
    this.minDate = this.dataset.minDate;
    this.maxDate = this.dataset.maxDate;
    this.blackoutDates = this.dataset.blackoutDates.split('<br />') || [];
    this.input = this.querySelector('input');
    this.init();
  }

  init() {
    flatpickr(`#${this.input.id}`, {
      dateFormat: 'Y-m-d',
      minDate: this.minDate,
      maxDate: this.maxDate,
      disable: this.blackoutDates,
      onChange: this.updateDeliveryDate.bind(this)
    });
  }

  async updateDeliveryDate(selectedDates, dateStr, instance) {
    if (dateStr === this.dataset.selectedDate) return;
    this.enableLoading();
    const cart = await fetch('/cart.js').then(r => r.json());
    
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          ...cart.attributes,
          delivery_date: dateStr
        }
      })
    })

    window.refreshCart();
    
    this.disableLoading();
    const responseJson = await response.json();
  }

  enableLoading() {
    this.input.disabled = true;
    this.classList.add('is-loading');
  }

  disableLoading() {
    this.input.disabled = false;
    this.classList.remove('is-loading');
  }
}
customElements.define('mealkit-datepicker', MealkitDatepicker);